module.exports = __webpack_public_path__ + "media/images/plus-75b9494c3d2e20e4016466e6d736bc75.png";